import { Component } from '@theme/component';

class MtWelcome extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.key = 'maxtime-welcome-v1';
    this.querySelector('.mt-welcome__launcher')?.addEventListener('click', () => this.open(), { signal });
    this.querySelector('.mt-welcome__close')?.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('close', () => { this.remember(); this.previousFocus?.focus(); }, { signal });
    this.dialog.addEventListener('click', (event) => {
      const rect = this.dialog.getBoundingClientRect();
      if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
    }, { signal });
    const demoForm = this.querySelector('[data-demo-form]');
    demoForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!demoForm.reportValidity()) return;
      demoForm.hidden = true;
      demoForm.style.display = 'none';
      demoForm.reset();
      const result = this.querySelector('[data-welcome-success]');
      result.hidden = false;
      result.focus();
      this.remember();
    }, { signal });
    const result = this.querySelector('[data-welcome-success]:not([hidden]),[data-welcome-errors]');
    if (result) { this.open(); if (!this.querySelector('[data-welcome-errors]')) this.remember(); }
    else {
      let seen = false;
      try { seen = sessionStorage.getItem(this.key) === '1'; } catch {}
      if (!seen) this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 1) * 1000);
    }
  }
  open() {
    if (!this.dialog?.isConnected || this.dialog.open || document.querySelector('dialog[open]')) return;
    this.previousFocus = document.activeElement;
    this.dialog.showModal();
  }
  remember() { try { sessionStorage.setItem(this.key, '1'); } catch {} }
  disconnectedCallback() { super.disconnectedCallback(); this.abort?.abort(); clearTimeout(this.timer); }
}
if (!customElements.get('mt-welcome')) customElements.define('mt-welcome', MtWelcome);
